import type { PreprocessingOptions } from "@models/doctype";
import { OptionSections, PREPROCESSING_SECTIONS } from "./RuntimeOptions";

interface PreprocessingOptionsFieldsProps {
    value: PreprocessingOptions | null;
    onChange: (value: PreprocessingOptions | null) => void;
}

export const PreprocessingOptionsFields = ({
    value,
    onChange,
}: PreprocessingOptionsFieldsProps) => (
    <OptionSections sections={PREPROCESSING_SECTIONS} value={value} onChange={onChange} />
);
